(function () {
    'use strict';

    angular
        .module('BCMControllers')
        .controller('BIAResponsibilityEditForBuOwnerController', Controller);

    Controller.$inject = ['$scope', '$state', 'biaProfileContainer', 'biaBuOwnerContainer', 'biaResponsibilityContainer', 'bcmLookups', 'biaResponsibilityService', 'biaBuOwnerService'];

    function Controller($scope, $state, biaProfileContainer, biaBuOwnerContainer, biaResponsibilityContainer, bcmLookups, biaResponsibilityService, biaBuOwnerService) {

        $scope.biaProfile = biaProfileContainer.BIAProfile;
        $scope.biaBuOwner = biaBuOwnerContainer.BIABUOwner;
        $scope.buOwnerBiaResponsibilities = biaBuOwnerContainer.BIAResponsibilities;
        $scope.biaResponsibility = biaResponsibilityContainer.BIAResponsibility;
        $scope.biaKeyPersons = biaResponsibilityContainer.BIAKeyPersons;
        $scope.iamSystemListByType = biaResponsibilityContainer.IAMSystemListByType;
        $scope.bcmLookups = bcmLookups;

        // Go to BIA Profile
        $scope.goToBIAProfile = function () {
            $state.go('biaProfile.edit');
        };

        // Responsibility Updated
        $scope.onResponsibilityUpdated = function(responsibility) {
            $scope.biaResponsibility = responsibility;
            biaResponsibilityContainer.BIAResponsibility = responsibility;
        };
    }
})();